export default __webpack_public_path__ + "static/media/B0002.d3aa8281.png";